import firebase from 'firebase/app';
import "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export default function firebaseConfig() {
    var firebaseConfig = {
    apiKey: "AIzaSyC_mb64AgwhqSoh7ynVKgMAJXRYlQBu5bM",
    authDomain: "pizza-utility.firebaseapp.com",
    projectId: "pizza-utility",
    storageBucket: "pizza-utility.appspot.com",
    messagingSenderId: "399296141799",
    appId: "1:399296141799:web:a5c6849e8a263d79fa4542",
    measurementId: "G-GGV1PGJVSH"
    };
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
    firebase.analytics();

    // console.log('firebase init complete');
}